exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "p {\n    font-size: 12px;\n}", "", {"version":3,"sources":["/Users/trops/Development/react_projects/swingbot-reactjs/website/swingbot-www/src/components/PrivacyPolicy.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;CACnB","file":"PrivacyPolicy.css","sourcesContent":["p {\n    font-size: 12px;\n}"],"sourceRoot":""}]);

// exports
